import {
    styled
} from '@mui/material/styles';
import {
    TextField,
    Input,
    Select
} from "@mui/material";

export const ValidationTextField = styled(TextField)({
    '& input:valid + fieldset': {
        borderColor: '#198754',
        borderWidth: 1,
        height: '50px',
        fontFamily: "Poppins-Regular",
        fontSize: '14px'
    },
    '& input:invalid + fieldset': {
        borderColor: '#f44250',
        borderWidth: 1,
        height: '50px',
        fontFamily: "Poppins-Regular",
        fontSize: '14px'
    },
    '& input:focus + fieldset': {
        borderColor: '#00B4E5'
    },
    '& input:optional + fieldset': {
        borderColor: "#0000003b"
    },
});
export const ValidationInput = styled(Input)({
    border: "1px solid #EDEDED",
    height: "40px",
    boxSizing: "border-box",
    padding: "10px",
    borderRadius: "3px",
    background: "#fff",
    marginTop:"0px!important",
    "&::before": {
       borderBottom: "0px!important"
    },
    "&::after": {
        border: "1px solid #00B4E5!important",
        top: 0,
        borderRadius: "3px",
        transition: "unset!important"
     },
});

export const ValidationTextFieldNoLabel = styled(TextField)({
  '& input:valid + fieldset': {
      border: 'none',
      boxShadow: 'none',
      height: '100%',
      fontFamily: "Poppins-Regular",
      fontSize: '12px',
      borderRadius: "8px",
      display: "block",
      boxSizing: 'border-box',
  },
  '& input': {
      border: '1px solid #E5E5E5',
      height: '40px',
      fontFamily: "Poppins-Regular",
      fontSize: '14px',
      borderRadius: "4px",
      display: "block",
      boxSizing: 'border-box',
      color: "#4B4B4B",
      background: "#fff",
      padding:' 15px 14px'
  },
  '& input:invalid + fieldset': {
      borderColor: '#E5E5E5',
  },
  '& input:hover + fieldset': {
      borderColor: '#E5E5E5',
  },
  '& input:focus': {
      boxShadow: "0 0 2px rgb(0 179 227), 0 0px 2px rgb(0 178 226)"
  },
});

// export const ValidationSelectField = styled(Select)(({
//     theme,
// }) => ({
//     "&.MuiOutlinedInput-root": {
//         "&.Mui-focused:valid fieldset": {
//             borderColor: '#198754'
//         },
//         "&.Mui-focused:focus fieldset": {
//             borderColor: '#00B4E5'
//         },
//         '&.Mui-focused:invalid + fieldset': {
//             borderColor: '#f44250',
//             borderWidth: 2,
//             height: '50px',
//             fontFamily: "Poppins-Regular",
//             fontSize: '14px'
//         },
//         '& input:optional + fieldset': {
//             borderColor: "#CACACA"
//         },
//     }
// }));

export const ValidationSelectField = styled(Select)(({ theme, touched, isfocused, isValid }) => ({
    "&.MuiOutlinedInput-root": {
      "&.Mui-focused:valid fieldset": {
        borderColor: isValid ? "#198754" : "#f44250",
        borderWidth: "1px !important"
      },
      "&.Mui-focused:focus fieldset": {
        borderColor: isfocused ? "#00B4E5" : "#0000003b",
        borderWidth: "1px !important"
      },
      "&.Mui-focused:invalid + fieldset": {
        borderColor: "#f44250",
        borderWidth: 1,
        height: '50px',
        fontFamily: "Poppins-Regular",
        fontSize: '14px'
      },
      "& fieldset": {
        borderColor: touched ? "#198754" : "#0000003b",
        borderWidth: "1px !important"
      },
    },
}));

export const AdminValidationSelectField = styled(Select)(({ touched, isfocused, isValid }) => ({
    height: "40px",
    backgroundColor: "#fff",
    "& fieldset": {
        borderColor: "#EDEDED",
        borderWidth: "1px !important"
    },
    "& .MuiOutlinedInput-root": {
        height: "40px",
        borderColor: "#EDEDED",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center", 
        "& fieldset": {
            borderColor: "#EDEDED",
            borderWidth: "1px !important"
        },
        "&.Mui-focused fieldset": {
            borderColor: isfocused ? "#00B4E5" : "#EDEDED",
            borderWidth: "1px !important"
        },
        "&.Mui-error fieldset": {
            borderColor: "#f44250",
            borderWidth: 1,
        },
    },
    "& .MuiSelect-select": {
        height: "100%",
        display: "flex",
        alignItems: "center",
        fontFamily: "Poppins-Regular",
        fontSize: "14px",
        padding: "8px 12px",
    },
}));
